import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { IPBoardHelper } from 'src/app/helpers/ip-board-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import ProjectHelper from 'src/app/helpers/project-helper';
import { StringHelper } from 'src/app/helpers/string-helper';
import Asset from 'src/app/model/asset';
import { BoardTypeChoices } from 'src/app/model/product/board/board-part';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import Product from 'src/app/model/product/product';
import { Project } from 'src/app/model/project/project';
import { SUB_PROJECT_TYPES } from 'src/app/model/project/sub-project';
import { ImmoMapSubProject } from '../../../services/model/immo-map-sub-project';

type AssetsObj = { assets?: Asset[]; firstAssetStyle?: any };
export class ImmoMapPopupInfoHelper {
  private constructor() {}

  static getInvolvedCompanies(project: Project): string[] {
    if (
      project != null &&
      CollectionHelper.isPopulated(project.projectContacts)
    ) {
      return ProjectHelper.getInvolvedCompanies(project).map(
        c => c.regularName
      );
    } else {
      return null;
    }
  }

  static preprocessProducts(products: Product[]): void {
    if (!CollectionHelper.isPopulated(products)) {
      return;
    }
    products.forEach(p => {
      if (!ProductHelper.isIPBoard(p)) {
        return;
      }
      const ipBoard = <IPBoard>p;
      if (
        ipBoard.boardPart != null &&
        ipBoard.boardPart.boardType != null &&
        ipBoard.boardPart.boardType.ordinal ===
          BoardTypeChoices.DIVERGENT.ordinal
      ) {
        ipBoard.overviewFormat = StringHelper.shortenText(
          StringHelper.join(
            [
              BoardTypeChoices.DIVERGENT.label,
              ipBoard.boardPart.divergentBoardType
            ],
            ': '
          ),
          100
        );
      } else {
        ipBoard.overviewFormat =
          ipBoard.boardPart == null
            ? null
            : StringHelper.shortenText(
                StringHelper.join(
                  [
                    IPBoardHelper.getShortMeasurements(ipBoard),
                    IPBoardHelper.getShortDescription(ipBoard)
                  ],
                  ' / '
                ),
                100
              );
      }
    });
  }

  static setFirstAssetStyle(assetsObj: AssetsObj): void {
    if (!CollectionHelper.isPopulated(assetsObj.assets)) {
      return;
    }
    const url = `/api/assets/${assetsObj.assets[0].uuid}`;
    assetsObj.firstAssetStyle = {
      'background-image': `url('${url}')`,
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'background-size': 'contain'
    };
  }

  static setTypeDisplays(subProject: ImmoMapSubProject): void {
    switch (subProject.type) {
      case SUB_PROJECT_TYPES.BASE_PROJECT:
        subProject.typeDisplay = 'Te plaatsen';
        subProject.typeClass = 'uitgevoerd';
        break;
      case SUB_PROJECT_TYPES.ADJUSTMENT:
        subProject.typeDisplay = 'Aanpassing';
        subProject.typeClass = 'aanpassing';
        break;
      case SUB_PROJECT_TYPES.SOLDRENTED:
        subProject.typeDisplay = 'Verkocht/Verhuurd';
        subProject.typeClass = 'verkocht-verhuurd';
        break;
      case SUB_PROJECT_TYPES.REPO:
        subProject.typeDisplay = 'Weghalen';
        subProject.typeClass = 'weghalen';
        break;
      case 'Task':
        subProject.typeDisplay = 'Taak';
        subProject.typeClass = 'immo-task-background';
        break;
      default:
        throw new Error(`subproject type not recognized: ${subProject.type}`);
    }
  }
}
